import TldlDurationBadge from './TldlDurationBadge';

export default TldlDurationBadge;
